import { render, staticRenderFns } from "./CollectedInventoryRequest.vue?vue&type=template&id=59c925f0&scoped=true&"
import script from "./CollectedInventoryRequest.vue?vue&type=script&lang=js&"
export * from "./CollectedInventoryRequest.vue?vue&type=script&lang=js&"
import style0 from "./CollectedInventoryRequest.vue?vue&type=style&index=0&id=59c925f0&prod&lang=scss&scoped=true&"
import style1 from "./CollectedInventoryRequest.vue?vue&type=style&index=1&id=59c925f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c925f0",
  null
  
)

export default component.exports